(() => {
  'use strict';
  // Official TrustBox display widgets load without optional cookie consent.
  const messages = {
    nl: ['Klantbeoordelingen op Trustpilot', 'Bekijk ervaringen met onze winkel op Trustpilot', 'Onze klantbeoordelingen', 'Lees wat klanten over onze winkel vertellen.', 'Reviews tonen', 'Sta Personalisatie toe in je cookievoorkeuren om de Trustpilot-widget te laden.', 'De cookievoorkeuren konden niet worden geopend. Probeer de knop onderaan de pagina.', 'Beoordeling van onze winkel'],
    en: ['Customer reviews on Trustpilot', 'Read reviews of our store on Trustpilot', 'Our customer reviews', 'Read what customers say about our store.', 'Show reviews', 'Allow Personalisation in your cookie preferences to load the Trustpilot widget.', 'Cookie preferences could not be opened. Try the button at the bottom of the page.', 'Our store rating'],
    de: ['Kundenbewertungen auf Trustpilot', 'Bewertungen unseres Shops auf Trustpilot lesen', 'Unsere Kundenbewertungen', 'Lesen Sie, was Kunden über unseren Shop sagen.', 'Bewertungen anzeigen', 'Erlauben Sie Personalisierung in Ihren Cookie-Einstellungen, um das Trustpilot-Widget zu laden.', 'Die Cookie-Einstellungen konnten nicht geöffnet werden. Nutzen Sie die Schaltfläche unten auf der Seite.', 'Bewertung unseres Shops'],
    fr: ['Avis clients sur Trustpilot', 'Lire les avis sur notre boutique sur Trustpilot', 'Les avis de nos clients', 'Découvrez les expériences de nos clients.', 'Afficher les avis', 'Autorisez la personnalisation dans vos préférences de cookies pour afficher le widget Trustpilot.', 'Impossible d’ouvrir les préférences de cookies. Essayez le bouton en bas de page.', 'Évaluation de notre boutique'],
    es: ['Opiniones de clientes en Trustpilot', 'Leer opiniones sobre nuestra tienda en Trustpilot', 'Opiniones de nuestros clientes', 'Descubre las experiencias de nuestros clientes.', 'Mostrar opiniones', 'Permite la personalización en tus preferencias de cookies para cargar el widget de Trustpilot.', 'No se pudieron abrir las preferencias de cookies. Prueba el botón al final de la página.', 'Valoración de nuestra tienda']
  };
  const lang = document.documentElement.lang.split('-')[0].toLowerCase();
  const text = messages[lang] || messages.en;
  const readyFrames = new WeakSet();
  const updates = new Map();
  window.addEventListener('message', event => {
    if (event.origin !== 'https://widget.trustpilot.com') return;
    let data;
    try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch { return; }
    if (!['loaded', 'ping', 'impression', 'resize-height'].includes(data?.command)) return;
    for (const [widget, update] of updates) {
      const frame = Array.from(widget.querySelectorAll('iframe')).find(frame => frame.contentWindow === event.source);
      if (frame) { readyFrames.add(frame); update(); break; }
    }
  });
  function prepare(root) {
    root.querySelectorAll('.trustpilot-widget').forEach(widget => {
      if (widget.dataset.mxproFallbackReady) return;
      let original = widget.querySelector('a[href*="trustpilot.com/review/mxprostoreparts.com"]');
      const alreadyEmbedded = !original;
      const productWidget = Boolean(widget.dataset.sku);
      const productList = productWidget && widget.dataset.templateId === '544a426205dc0a09088833c6';
      const productHost = productList ? widget.closest('section.shopify-section.section') : null;
      const isolatedProductHost = productHost && productHost.querySelectorAll('.trustpilot-widget').length === 1 ? productHost : null;
      if (isolatedProductHost) isolatedProductHost.classList.add('mxpro-product-reviews-host');
      if (!original) {
        if (widget.dataset.businessunitId !== '68b55cba7630f16cf2bb440d') return;
        original = document.createElement('a');
      }
      widget.dataset.mxproFallbackReady = 'true';
      const fallback = document.createElement('div');
      fallback.className = 'mxpro-review-placeholder';
      fallback.dataset.reviewLayout = parseInt(widget.dataset.styleHeight || '0', 10) > 30 ? 'card' : 'compact';
      const link = original.cloneNode(false);
      link.className = 'mxpro-review-fallback';
      link.textContent = text[widget.dataset.sku ? 1 : 0] + ' ↗';
      link.rel = 'noopener noreferrer';
      link.href = 'https://www.trustpilot.com/review/mxprostoreparts.com';
      link.target = '_blank';
      fallback.append(link);
      if (productWidget && !productList) {
        fallback.classList.add('mxpro-review-placeholder--store');
        const caption = document.createElement('span');
        caption.className = 'mxpro-review-store-caption';
        caption.textContent = text[7];
        const service = document.createElement('div');
        service.className = 'trustpilot-widget';
        service.dataset.locale = widget.dataset.locale || 'en-GB';
        service.dataset.templateId = '5419b6ffb0d04a076446a9af';
        service.dataset.businessunitId = '68b55cba7630f16cf2bb440d';
        service.dataset.styleHeight = '20px';
        service.dataset.styleWidth = '100%';
        service.dataset.theme = 'light';
        service.dataset.mxproStoreFallback = 'true';
        service.append(link.cloneNode(true));
        fallback.replaceChildren(caption, service);
      }
      widget.insertAdjacentElement('afterend', fallback);
      original.classList.add('mxpro-review-original');
      const update = () => {
        const frames = Array.from(widget.querySelectorAll('iframe'));
        const loaded = frames.some(frame => readyFrames.has(frame) && frame.getBoundingClientRect().height > 8 && getComputedStyle(frame).display !== 'none');
        widget.classList.toggle('mxpro-review-loaded', loaded);
        fallback.hidden = loaded || productList;
        if (isolatedProductHost) isolatedProductHost.classList.toggle('mxpro-product-reviews-host--loaded', loaded);
        frames.forEach(frame => resize.observe(frame));
      };
      const resize = new ResizeObserver(update);
      const changes = new MutationObserver(update);
      changes.observe(widget, {childList:true, subtree:true, attributes:true, attributeFilter:['style','height']});
      updates.set(widget, update);
      update();
      if (productWidget && !productList) prepare(fallback);
      if ((alreadyEmbedded || widget.dataset.mxproStoreFallback === 'true') && window.Trustpilot?.loadFromElement) window.Trustpilot.loadFromElement(widget, true);
    });
    root.querySelectorAll('.c-trustpilot-reviews__title').forEach(el => { el.textContent = text[2]; });
    root.querySelectorAll('.c-trustpilot-reviews__description').forEach(el => { el.textContent = text[3]; });
  }
  prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
